import React from 'react';
import Modal from 'react-bootstrap/Modal';

// styles
import ModalStyles from "../../DashboardReuseAbleComponents/Modal.module.css"

const SuccessModal = (props) => {
    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 647px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'></Modal.Header>
                <Modal.Body dir='rtl'>
                    <div className='w-100 d-flex flex-column align-items-center justify-content-center py-2'>
                        <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
                            <div className='my-3'>
                                <svg width="67" height="67" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M33.9579 0.594854C15.4513 0.344894 0.34294 15.4533 0.592901 33.9599C0.839698 51.7087 15.2916 66.1606 33.0404 66.4074C51.5501 66.6605 66.6554 51.5521 66.4022 33.0455C66.1586 15.2935 51.7068 0.841651 33.9579 0.594854ZM31.3017 31.0442L39.4571 21.7102C39.8989 21.2046 40.5235 20.8953 41.1934 20.8502C41.8633 20.8051 42.5237 21.0279 43.0293 21.4698C43.5349 21.9116 43.8443 22.5361 43.8894 23.2061C43.9345 23.876 43.7116 24.5364 43.2698 25.042L35.1144 34.376C34.8956 34.6263 34.6297 34.8311 34.3318 34.9787C34.0339 35.1263 33.7098 35.2137 33.3781 35.236C33.0464 35.2584 32.7135 35.2151 32.3985 35.1088C32.0835 35.0025 31.7925 34.8352 31.5422 34.6164C31.2918 34.3977 31.087 34.1317 30.9395 33.8338C30.7919 33.5359 30.7044 33.2118 30.6821 32.8801C30.6598 32.5484 30.703 32.2156 30.8093 31.9005C30.9156 31.5855 31.0829 31.2946 31.3017 31.0442ZM25.1539 45.417C24.6793 45.8913 24.0357 46.1578 23.3647 46.1578C22.6936 46.1578 22.05 45.8913 21.5754 45.417L13.9895 37.8232C13.7546 37.588 13.5682 37.3089 13.4411 37.0017C13.3141 36.6945 13.2487 36.3653 13.2489 36.0328C13.249 35.7004 13.3146 35.3712 13.442 35.0641C13.5694 34.757 13.7559 34.4781 13.9911 34.2431C14.2263 34.0081 14.5055 33.8218 14.8127 33.6947C15.1199 33.5676 15.4491 33.5023 15.7815 33.5024C16.114 33.5025 16.4431 33.5682 16.7502 33.6955C17.0573 33.8229 17.3363 34.0095 17.5713 34.2447L25.165 41.8384C25.6379 42.3145 25.9024 42.9589 25.9003 43.63C25.8982 44.301 25.6298 44.9438 25.1539 45.417ZM53.1243 25.042L35.4245 45.292C35.1964 45.5533 34.9171 45.7649 34.6039 45.9138C34.2907 46.0626 33.9502 46.1455 33.6036 46.1574H33.5181C33.1855 46.1574 32.8562 46.0919 32.5489 45.9646C32.2416 45.8373 31.9624 45.6507 31.7273 45.4154L24.143 37.8216C23.6685 37.3467 23.402 36.7026 23.4023 36.0312C23.4026 35.3598 23.6696 34.716 24.1446 34.2415C24.6196 33.7669 25.2636 33.5005 25.935 33.5008C26.6064 33.5011 27.2502 33.7681 27.7247 34.2431L32.4392 38.9623C32.5618 39.0849 32.7082 39.181 32.8694 39.2446C33.0306 39.3083 33.2032 39.3382 33.3765 39.3324C33.5497 39.3266 33.72 39.2853 33.8766 39.211C34.0332 39.1367 34.1729 39.0311 34.287 38.9006L49.3163 21.7102C49.7581 21.2046 50.3827 20.8953 51.0526 20.8502C51.7225 20.8051 52.3829 21.0279 52.8885 21.4698C53.3941 21.9116 53.7035 22.5361 53.7486 23.2061C53.7937 23.876 53.5708 24.5364 53.129 25.042H53.1243Z" fill="#449114" />
                                </svg>
                            </div>
                            <div className={`my-2 ${ModalStyles.title}`}>
                                فایل شما با موفقیت تکمیل شد.
                            </div>
                            <div className={`my-2 ${ModalStyles.text_black_sm}`}>
                                برای مشاهده فایل به قسمت مدیریت فایل ها بروید
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={props.onHide}>
                            باشه
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SuccessModal;